import { Component, inject } from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {HuntersService} from '../../service/hunters.service';
import {DynamicHooksComponent} from 'ngx-dynamic-hooks';

@Component({
	selector: 'hunters-banner-component',
	template: `
		<ngx-dynamic-hooks
				[options]="{ sanitize: false }"
				[content]="bannerHtml?.toString()">
		</ngx-dynamic-hooks>`,
	standalone: true,
	imports: [DynamicHooksComponent],
})
export class HuntersBannerComponent {
	private huntersService = inject(HuntersService);

	bannerHtml: SafeHtml;

	ngOnInit() {
		this.huntersService
			.getHuntersBanner()
			.then(result => (this.bannerHtml = result));
	}
}
